import { BehaviorSubject, Observable } from 'rxjs';


export abstract class SignalService<T> {

  private behaviorSubject = new BehaviorSubject<T>(null);
  protected obervableSignal$: Observable<T> = this.behaviorSubject.asObservable();

  protected pushSignal(t: T) {
    this.behaviorSubject.next(t);
  }

  protected pushSignalReset(t: T) {
    this.behaviorSubject.next(t);
    this.behaviorSubject.next(undefined)
  }

}
